module.exports = __webpack_public_path__ + "static/media/call_successfully_connected_sound.395e861.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/sounds/call_successfully_connected_sound.mp3
// module id = 399
// module chunks = 1